/*@flow*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobileOnly, isBrowser } from 'react-device-detect';

import { Wrapper } from './style';
import HelpIcon from '../../assets/images/help.svg';
import { FormattedMessage } from 'react-intl';
import ReactSVG from 'react-svg';

type Props = {
  title: string,
  displayHelp?: boolean
};

type State = {
  opacity: 1 | 0
};

class SubHeader extends Component<Props, State> {
  state = {
    opacity: 0
  };

  handleHoverOver = () => {
    isBrowser && this.setState({ opacity: 1 });
  };

  handleHoverOut = () => {
    isBrowser && this.setState({ opacity: 0 });
  };

  handleToggl = () => {
    this.setState({ opacity: this.state.opacity === 1 ? 0 : 1 });
  };

  render() {
    const { title, displayHelp = false } = this.props;
    const { opacity } = this.state;

    const titleExploded = title.split(' ');
    const firstWord = titleExploded.shift();
    const rest = titleExploded.join(' ');

    return (
      <Wrapper>
        <div
          className="text-help-container"
          style={{ opacity, display: opacity === 1 ? 'flex' : 'none' }}
        >
          {!isMobileOnly && (
            <div>
              <ReactSVG
                svgStyle={{ width: 150, color: '#f7f7f6', marginRight: 54 }}
                src={HelpIcon}
              />
            </div>
          )}
          <div style={{ width: isMobileOnly ? '90%' : '45%' }}>
            <FormattedMessage id="subHeader.help.sentence1" />
            <br />
            <br />➔ <FormattedMessage id="subHeader.help.chip1" />
            <br />
            <br />➔ <FormattedMessage id="subHeader.help.chip2" />
            <br />
            <br />
            <FormattedMessage id="subHeader.help.sentence2" />
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default SubHeader;



// WEBPACK FOOTER //
// ./src/components/SubHeader/index.js